import React from 'react';
import { ResourceCenter } from 'cccisd-laravel-resources';

const ResourcesTab = () => {
    return <ResourceCenter handle="default" />;
};

export default ResourcesTab;
